// extracted by mini-css-extract-plugin
module.exports = {"empty":"cards_empty__njGRF","list-cards":"cards_list-cards__eoWIP"};